// Fonte: UManutContas.dfm — Painel P3, Ds_Despesa → tabela Contas_De_Despesas
// Regra especial: Tipos 3 e 7 propagam para TODOS os GEs ativos
import React, { useState } from 'react';
import { Form, Row, Col, Card, Alert, Collapse } from 'react-bootstrap';
import Select from 'react-select';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

// Fonte: UManutContas.dfm linha 2413 — Tipo_Des: ordem Compensação, Normal
var TIPO_DESPESA = [
  { value: 'C', label: 'Compensação' },
  { value: 'N', label: 'Normal' },
];

var FormTipo3 = function(_ref) {
  var formik = _ref.formik;
  var modoEdicao = _ref.modoEdicao;

  var val = function(campo) {
    var v = formik.values['tipo3'] ? formik.values['tipo3'][campo] : undefined;
    return v !== null && v !== undefined ? v : '';
  };

  var [aberto, setAberto] = useState(true);

  return (
    <Card className="shadow-sm mb-3">
      <Card.Header className="py-2 contas-card-header" style={{ cursor: 'pointer' }} onClick={function() { setAberto(!aberto); }}>
        <div className="d-flex justify-content-between align-items-center">
          <strong>Dados do Tipo: Despesa</strong>
          {aberto ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
        </div>
      </Card.Header>
      <Collapse in={aberto}>
        <div>
      <Card.Body>
        <Alert variant="info" className="py-2 px-3 mb-3">
          <small>
            <strong>Atenção:</strong> Contas de Despesa são propagadas automaticamente para todos os GEs ativos.
          </small>
        </Alert>
        <Row>
          <Col md={3} className="mb-3">
            {/* Fonte: UManutContas.pas linha 2409 — Descricao_Conta := Apelido_Conta (sempre) */}
            <Form.Label className="small mb-1">Descrição</Form.Label>
            <Form.Control
              type="text" size="sm"
              value={formik.values.apelido_conta || ''}
              disabled readOnly
            />
            <Form.Text muted>Sincronizada com Apelido.</Form.Text>
          </Col>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">Tipo</Form.Label>
            <Select
              options={TIPO_DESPESA}
              isClearable
              value={TIPO_DESPESA.find(function(t) { return t.value === val('tipo_des'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo3.tipo_des', opt ? opt.value : null);
              }}
              isDisabled={!modoEdicao}
            />
          </Col>
        </Row>
      </Card.Body>
        </div>
      </Collapse>
    </Card>
  );
};

export default FormTipo3;
